export default __webpack_public_path__ + "static/media/Circle.37207f24.svg";